import type { BookingDetailsState } from '../../domain/types'
import type { ParticipantFullName } from '../utils/participantName'
import { isActiveUpcomingBooking } from '@/scopes/account/common/utils/bookingDates'
import { getParticipantFullName, getParticipantsByStatus } from './participantsSelectors'

export function getIsAddSpecialLuggageAvailable(state: BookingDetailsState, now: Date = new Date()): boolean {
  return isActiveUpcomingBooking(state.rawDepartureDate, state.isCancelled, now)
}

export function getActiveParticipantOptions(state: BookingDetailsState): { value: string, fullName: ParticipantFullName }[] {
  return getParticipantsByStatus(state).active.map(p => ({
    value: p.id,
    fullName: getParticipantFullName(p),
  }))
}
